import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
// @ts-ignore
import ApexCharts from 'apexcharts';
import Swal from 'sweetalert2';
var SolardashboardComponent = /** @class */ (function () {
    function SolardashboardComponent(solarService) {
        this.solarService = solarService;
        this.kwhDatas = [];
        this.selectedMonth = 'this';
        this.cost = 7;
        this.calculatedValue = 0;
        // This is the array used for rendering calendar day cells
        this.calendarDays = [];
        this.generationStats = [
            { value: '0000', label: 'This_Month' },
            { value: '0000', label: 'Last_Month' },
            { value: '0000', label: 'Today' },
            { value: '0000', label: 'Yesterday' },
        ];
        this.selectedDuration = 'Today';
        this.durationOptions = [
            'Today',
            'Yesterday',
            'This Week',
            'This Month',
            'Last Month'
        ];
        this.assetsData = [];
        this.unitPrice = 7;
        this.selectedTab = 0;
        this.totalPrice = 0;
        this.tabOptions = [
            { label: 'Today', labelShort: 'T' },
            { label: 'Yesterday', labelShort: 'Y' },
            { label: 'This Week', labelShort: 'W' },
            { label: 'This Month', labelShort: 'M' },
            { label: 'Last Month', labelShort: 'LM' }
        ];
        this.kwhData = {
            0: 12,
            1: 18,
            2: 140,
            3: 530,
            4: 640
        };
        this.assetIDList = [];
        this.expectedData = 0;
        this.loss = 0;
        this.co2Data = { co2Kg: 0, treesPlanted: 0, milesOffset: 0, homesPowered: 0 };
        this.connected = 0;
        this.disconnected = 0;
        this.selectedFilter = 'daily';
        this.selectedFilterPerformance = 'daily';
    }
    Object.defineProperty(SolardashboardComponent.prototype, "currentKwh", {
        get: function () {
            return this.kwhData[this.selectedTab] || 0;
        },
        enumerable: true,
        configurable: true
    });
    SolardashboardComponent.prototype.ngOnInit = function () {
        var today = new Date();
        this.currentYear = today.getFullYear();
        this.currentMonth = today.getMonth();
        this.getAssetId();
        this.getWeather();
    };
    SolardashboardComponent.prototype.consumptionBarChart = function () {
        var options = {
            series: [{
                    name: "Daily",
                    data: [0]
                }],
            chart: {
                type: 'bar',
                height: '100%',
                toolbar: {
                    show: true,
                    tools: {
                        download: true // <-- this enables SVG, PNG, CSV
                    }
                },
                events: {
                    legendClick: function (chartContext, seriesIndex) {
                        var legendName = options.series[seriesIndex].name;
                        // Optional: trigger popup
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                }
            },
            colors: ["#008000", "#808080"],
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: [0],
                labels: {
                    style: {
                        fontSize: '12px'
                    }
                }
            },
            yaxis: {
                title: {
                    text: 'Consumption'
                }
            },
            fill: {
                opacity: 1,
                type: "gradient"
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + " Kwh";
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right'
            },
            grid: {
                show: false
            }
        };
        this.generationgraphObject = new ApexCharts(document.querySelector("#barChart"), options);
        this.generationgraphObject.render();
    };
    SolardashboardComponent.prototype.deviceStatus = function (connected, disconnected) {
        var seriesData = [connected, disconnected];
        var options = {
            series: seriesData,
            chart: {
                height: "100%",
                type: 'pie',
                events: {
                    legendClick: function (chartContext, seriesIndex) {
                        var legendName = options.labels[seriesIndex];
                        //this.popupTable(legendName, this.deviceConnectionStatus);
                    }
                },
            },
            colors: ["#008000", "#808080"],
            labels: ["Connected", "Disconnected"],
            dataLabels: {
                enabled: false,
            },
            fill: {
                type: 'gradient',
            },
            legend: {
                position: 'right',
                formatter: function (val, opts) {
                    // Add the image only for "disconnected" legend item
                    if (val.toLowerCase() === "disconnected") {
                        return "<span style=\"font-weight: bolder; cursor: pointer;\">\n              " + val + " :<b style=\"font-size:2vh;\"> " + opts.w.globals.series[opts.seriesIndex] + "</b><br>\n              \n            </span>";
                    }
                    return "<span style=\"font-weight: bolder; cursor: pointer;\">\n            " + val + " :<b style=\"font-size:2vh;\"> " + opts.w.globals.series[opts.seriesIndex] + "</b>\n          </span>";
                },
                labels: {
                    useSeriesColors: true,
                },
            },
        };
        var chart = new ApexCharts(document.querySelector("#deviceStatus"), options);
        chart.render();
    };
    SolardashboardComponent.prototype.performanceDegradationChart = function (performanceData) {
        var seriesData = performanceData.map(function (d) { return d.performance_change_percent; });
        var categories = performanceData.map(function (d) { return d.month; });
        // Generate per-point marker colors
        var markerColors = performanceData.map(function (d) { return (d.status == 'improved' ? '#00c49f' : '#f44336'); }); // green / red
        var discreteMarkers = performanceData.map(function (d, i) { return ({
            seriesIndex: 0,
            dataPointIndex: i,
            fillColor: d.status === 'improved' ? '#00c49f' : '#f44336',
            strokeColor: d.status === 'improved' ? '#00c49f' : '#f44336',
            size: 6
        }); });
        var performanceDegradationChartOptions = {
            series: [{
                    name: 'Performance',
                    data: seriesData
                }],
            chart: {
                type: 'line',
                height: '100%',
                toolbar: { show: false },
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 800,
                    animateGradually: { enabled: true, delay: 150 },
                    dynamicAnimation: { enabled: true, speed: 350 }
                }
            },
            stroke: {
                curve: 'smooth',
                width: 3,
                colors: ['#00c49f']
            },
            markers: {
                size: 5,
                discrete: discreteMarkers,
                hover: {
                    size: 8
                }
            },
            xaxis: {
                categories: categories,
                title: {
                    text: 'Month',
                    style: { fontSize: '14px', color: '#888' }
                },
                labels: {
                    style: { fontSize: '12px', colors: '#555' }
                }
            },
            yaxis: {
                title: {
                    text: 'Change (%)',
                    style: { fontSize: '14px', color: '#888' }
                },
                labels: {
                    formatter: function (val) { return val.toFixed(1) + "%"; },
                    style: { fontSize: '12px', colors: '#555' }
                }
            },
            tooltip: {
                theme: 'light',
                y: {
                    formatter: function (val) { return val.toFixed(2) + "%"; }
                }
            },
            grid: {
                borderColor: '#e0e0e0',
                strokeDashArray: 4,
                padding: { left: 10, right: 10, bottom: 0 }
            },
            responsive: [
                {
                    breakpoint: 600,
                    options: {
                        chart: { height: 300 },
                        xaxis: {
                            labels: { rotate: -45 }
                        }
                    }
                }
            ]
        };
        // Render the chart
        var chart = new ApexCharts(document.querySelector("#performanceDegradation"), performanceDegradationChartOptions);
        chart.render();
    };
    SolardashboardComponent.prototype.getAssetId = function () {
        var _this = this;
        this.solarService.getSolarAssetId(JSON.parse(localStorage.getItem('userData'))).subscribe(function (res) {
            if (res.status) {
                _this.assetIDList = res.data.map(function (element) { return element.serialNo; });
                console.log("adsda", _this.assetIDList);
                _this.consumptionBarChart();
                _this.generationGraphDaily(_this.assetIDList);
                _this.performanceDegradation(_this.assetIDList);
                _this.renderCalendar();
                _this.getDeviceStatus(_this.assetIDList);
                _this.solarService.getGeneration({ assetids: _this.assetIDList }).subscribe(function (resp) {
                    if (resp.status) {
                        _this.generationStats = _this.generationStats.map(function (stat) { return (tslib_1.__assign({}, stat, { value: resp.data[stat.label] !== undefined
                                ? resp.data[stat.label].toFixed(2)
                                : '0000' })); });
                        _this.solarService.getGenerationPerAsset({ assetids: _this.assetIDList }).subscribe(function (response) {
                            if (response.status) {
                                _this.assetsData = response.data;
                                // this.selectDuration("Today")
                                var totalLoggedSum_1 = response.data.reduce(function (sum, item) { return sum + (Number(item.Total_Logged_KWH) || 0); }, 0);
                                _this.generationStats.forEach(function (item) {
                                    if (item.label == 'Total_Logged') {
                                        item.value = totalLoggedSum_1.toFixed(2);
                                    }
                                });
                                _this.EO2Emission();
                            }
                        });
                        _this.calculate();
                    }
                    else {
                        Swal.fire({
                            title: 'Error!',
                            text: resp.message,
                            icon: 'error',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            backdrop: true
                        });
                    }
                });
            }
            else {
                Swal.fire({
                    title: 'Error!',
                    text: res.message,
                    icon: 'error',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    backdrop: true
                });
            }
        });
    };
    SolardashboardComponent.prototype.getDeviceStatus = function (data) {
        var _this = this;
        this.solarService.getDeviceStatus({ assetid: data }).subscribe(function (res) {
            if (res.status) {
                console.log("what is count", res.data);
                var connected = res.data.length;
                var disconnected = _this.assetIDList.length - res.data.length;
                _this.deviceStatus(connected, disconnected);
            }
        });
    };
    SolardashboardComponent.prototype.onFilterSelect = function (filter) {
        this.selectedFilter = filter;
        if (filter == 'daily') {
            this.generationGraphDaily(this.assetIDList);
        }
        else if (filter == 'weekly') {
            this.generationGraphWeekly(this.assetIDList);
        }
        else if (filter == "monthly") {
            this.generationGraphMonthly(this.assetIDList);
        }
        // You can also trigger chart updates here
        console.log('Filter selected:', filter);
    };
    SolardashboardComponent.prototype.onFilterSelecPerformancet = function (filter) {
        this.selectedFilterPerformance = filter;
        // You can also trigger chart updates here
        console.log('Filter selected:', filter);
    };
    SolardashboardComponent.prototype.selectDuration = function (option) {
        this.selectedDuration = option;
        if (option == "Today") {
            this.expectedData = this.assetsData.reduce(function (sum, item) { return sum + (Number(item.Expected_Today_KWH) || 0); }, 0);
            this.actualData = this.generationStats.find(function (resp) { return resp.label == "Today"; }).value;
            this.loss = Number(this.expectedData - this.actualData).toFixed(2);
        }
        else if (option == "Yesterday") {
            this.expectedData = this.assetsData.reduce(function (sum, item) { return sum + (Number(item.Expected_Yesterday_KWH) || 0); }, 0);
            this.actualData = this.generationStats.find(function (resp) { return resp.label == "Yesterday"; }).value;
            this.loss = Number(this.expectedData - this.actualData).toFixed(2);
        }
        else if (option == "This Week") {
            this.expectedData = this.assetsData.reduce(function (sum, item) { return sum + (Number(item.Expected_This_Week_KWH) || 0); }, 0);
            this.actualData = this.generationStats.find(function (resp) { return resp.label == "This_Week"; }).value;
            this.loss = Number(this.expectedData - this.actualData).toFixed(2);
        }
        else if (option == "This Month") {
            this.expectedData = this.assetsData.reduce(function (sum, item) { return sum + (Number(item.Expected_This_Month_KWH) || 0); }, 0);
            this.actualData = this.generationStats.find(function (resp) { return resp.label == "This_Month"; }).value;
            this.loss = Number(this.expectedData - this.actualData).toFixed(2);
        }
        else if (option == "Last Month") {
            this.expectedData = this.assetsData.reduce(function (sum, item) { return sum + (Number(item.Expected_Last_Month_KWH) || 0); }, 0);
            this.actualData = this.generationStats.find(function (resp) { return resp.label == "Last_Month"; }).value;
            this.loss = Number(this.expectedData - this.actualData).toFixed(2);
        }
    };
    SolardashboardComponent.prototype.calculateTotal = function () {
        var units = this.currentKwh / 1000;
        this.totalPrice = units * this.unitPrice;
    };
    SolardashboardComponent.prototype.onTabChange = function (event) {
        this.selectedTab = event.value;
        this.calculateTotal();
    };
    SolardashboardComponent.prototype.EO2Emission = function () {
        var kwh = 0;
        var CO2_PER_KWH = 0.417;
        var TREE_CO2_ABSORPTION = 21;
        var CO2_PER_CAR_MILE = 0.404;
        var KWH_PER_HOME = 10715;
        this.generationStats.forEach(function (item) {
            if (item.label == 'This_Month') {
                kwh = item.value;
            }
        });
        var co2Kg = Number(kwh) * Number(CO2_PER_KWH);
        var treesPlanted = Number(co2Kg) / Number(TREE_CO2_ABSORPTION);
        var milesOffset = Number(co2Kg) / Number(CO2_PER_CAR_MILE);
        var homesPowered = Number(kwh) / Number(KWH_PER_HOME);
        this.co2Data = { co2Kg: co2Kg, treesPlanted: treesPlanted, milesOffset: milesOffset, homesPowered: homesPowered };
    };
    SolardashboardComponent.prototype.generationGraphDaily = function (data) {
        var _this = this;
        this.solarService.generationGraph({ assetid: data }).subscribe(function (resp) {
            if (resp.status) {
                var categories = resp.data.map(function (item) { return item.day; });
                var dataSeries = resp.data.map(function (item) { return parseFloat(item.total_kwh.toFixed(2)); });
                _this.generationgraphObject.updateOptions({
                    xaxis: {
                        categories: categories,
                        title: {
                            text: 'Date'
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Total kWh'
                        }
                    },
                    series: [
                        {
                            name: 'kWh',
                            data: dataSeries
                        }
                    ],
                    title: {
                        text: _this.selectedFilter + " Generation kWh",
                        align: 'center'
                    }
                });
            }
        });
    };
    SolardashboardComponent.prototype.generationGraphWeekly = function (data) {
        var _this = this;
        this.solarService.generationGraphWeekly({ assetid: data }).subscribe(function (resp) {
            if (resp.status) {
                console.log("ererr", resp);
                var categories = resp.data.map(function (item) { return item.week_range; });
                var dataSeries = resp.data.map(function (item) { return parseFloat(item.total_kwh).toFixed(2); });
                console.log("asdasdassad", categories);
                _this.generationgraphObject.updateOptions({
                    xaxis: {
                        categories: categories,
                        title: {
                            text: 'Date'
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Total kWh'
                        }
                    },
                    series: [
                        {
                            name: 'kWh',
                            data: dataSeries
                        }
                    ],
                    title: {
                        text: _this.selectedFilter + " Generation kWh)",
                        align: 'center'
                    }
                });
            }
        });
    };
    SolardashboardComponent.prototype.performanceDegradation = function (data) {
        var _this = this;
        console.log("IN Performance Degradation ");
        this.solarService.generationGraphMonthly({ assetid: data }).subscribe(function (resp) {
            if (resp.status) {
                var degradation = [];
                var lastValid = null;
                for (var i = 0; i < resp.data.length; i++) {
                    var month = resp.data[i].month;
                    var kwh = parseFloat(resp.data[i].total_kwh);
                    if (kwh > 0 && lastValid !== null) {
                        var percentChange = ((kwh - lastValid.kwh) / lastValid.kwh) * 100;
                        var status_1 = percentChange < 0 ? 'degraded' : 'improved';
                        degradation.push({
                            month: month,
                            current_kwh: kwh,
                            previous_kwh: lastValid.kwh,
                            performance_change_percent: parseFloat(percentChange.toFixed(2)),
                            status: status_1
                        });
                        console.log("Performance Change Data", degradation);
                        lastValid = { month: month, kwh: kwh };
                    }
                    else if (kwh > 0) {
                        lastValid = { month: month, kwh: kwh };
                    }
                }
                _this.performanceDegradationChart(degradation);
            }
        });
    };
    SolardashboardComponent.prototype.generationGraphMonthly = function (data) {
        var _this = this;
        this.solarService.generationGraphMonthly({ assetid: data }).subscribe(function (resp) {
            if (resp.status) {
                var categories = resp.data.map(function (item) { return item.month; });
                var dataSeries = resp.data.map(function (item) { return parseFloat(item.total_kwh).toFixed(2); });
                _this.generationgraphObject.updateOptions({
                    xaxis: {
                        categories: categories,
                        title: {
                            text: 'Date'
                        }
                    },
                    yaxis: {
                        title: {
                            text: 'Total kWh'
                        }
                    },
                    series: [
                        {
                            name: 'kWh',
                            data: dataSeries
                        }
                    ],
                    title: {
                        text: _this.selectedFilter + " Generation kWh)",
                        align: 'center'
                    }
                });
            }
        });
    };
    SolardashboardComponent.prototype.getWeather = function () {
        var _this = this;
        this.solarService.getWeatherData(JSON.parse(localStorage.getItem('userData'))).subscribe(function (resp) {
            console.log("weatherData", resp.data);
            if (resp.status) {
                _this.weatherData = resp.data;
            }
        });
    };
    SolardashboardComponent.prototype.getMonthName = function (monthIndex) {
        var months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        return months[monthIndex];
    };
    SolardashboardComponent.prototype.renderCalendar = function () {
        var _this = this;
        this.solarService.getCalenderData({ assetid: this.assetIDList }).subscribe(function (response) {
            if (response.status) {
                _this.kwhDatas = response.data;
                _this.monthName = _this.getMonthName(_this.currentMonth);
                console.log("asdasdasd curret month", _this.currentMonth, _this.monthName);
                var firstDay = new Date(_this.currentYear, _this.currentMonth, 1);
                var lastDay = new Date(_this.currentYear, _this.currentMonth + 1, 0);
                _this.daysInMonth = lastDay.getDate();
                _this.startWeekDay = firstDay.getDay();
                _this.calendarDays = [];
                // Add empty cells before the first day
                for (var i = 0; i < _this.startWeekDay; i++) {
                    _this.calendarDays.push({ day: null });
                }
                console.log("is KWH Found ", firstDay);
                var _loop_1 = function (day) {
                    var dateStr = new Date(_this.currentYear, _this.currentMonth, day).toLocaleDateString('en-CA').slice(0, 10);
                    var kwhEntry = _this.kwhDatas.find(function (entry) { return entry.date == dateStr; });
                    var colorClass = '';
                    if (kwhEntry) {
                        if (kwhEntry.kwh >= 6)
                            colorClass = 'bg-high';
                        else if (kwhEntry.kwh >= 3)
                            colorClass = 'bg-medium';
                        else if (kwhEntry.kwh > 0)
                            colorClass = 'bg-low';
                    }
                    //console.log("this are dayt",day, kwhEntry ? kwhEntry : undefined,dateStr,this.daysInMonth)
                    _this.calendarDays.push({
                        day: day,
                        kwh: kwhEntry ? kwhEntry.kwh : undefined,
                        colorClass: colorClass
                    });
                };
                // Add days with kWh info if available
                for (var day = 1; day <= _this.daysInMonth; day++) {
                    _loop_1(day);
                }
            }
        });
    };
    SolardashboardComponent.prototype.prevMonth = function () {
        if (this.currentMonth === 0) {
            this.currentMonth = 11;
            this.currentYear--;
        }
        else {
            this.currentMonth--;
        }
        this.renderCalendar();
    };
    SolardashboardComponent.prototype.nextMonth = function () {
        if (this.currentMonth === 11) {
            this.currentMonth = 0;
            this.currentYear++;
        }
        else {
            this.currentMonth++;
        }
        this.renderCalendar();
    };
    SolardashboardComponent.prototype.setMonth = function (type) {
        this.selectedMonth = type;
        this.calculate();
    };
    SolardashboardComponent.prototype.calculate = function () {
        if (this.selectedMonth === 'this') {
            this.calculatedValue = Math.round(this.cost * Number(this.generationStats.find(function (resp) { return resp.label == "This_Month"; }).value));
        }
        else {
            this.calculatedValue = Math.round(this.cost * Number(this.generationStats.find(function (resp) { return resp.label == "Last_Month"; }).value));
        }
    };
    return SolardashboardComponent;
}());
export { SolardashboardComponent };
